module.exports = "/assets/images/closeBold_9072e0.svg";